  
<template>
    <div class="magazine-router SemiBold col-md-12">
          <span class="CheckOption Regular" >{{$t('message.Category')}}</span>
          <div> 
              <a href="javascript:;" @click="changeInnerTab('All')">{{$t('message.All')}}</a>
                <div class="orangeArticle" v-if="zi == 'All'"></div>
              </div>
          <span>|</span>
          <div>
               <a href="javascript:;" @click="changeInnerTab('Feature Story')">{{$t('message.The Headline')}}</a>
               <div class="orangeArticle"  v-if="zi == 'Feature Story'"></div>
          </div>
          <span>|</span>
          <div>
              <a href="javascript:;" @click="changeInnerTab('Side Story')">{{$t('message.Feature stories')}}</a>
               <div class="orangeArticle" v-if="zi == 'Side Story'"></div>
          </div>
          <span>|</span>
          <div>
                <a href="javascript:;" @click="changeInnerTab('Column')" >{{$t('message.Columns')}}</a>
                <div class="orangeArticle" v-if="zi == 'Column'"></div>
          </div>
          <a class="displayA" v-bind:href="'./magazine?lang='+$store.state.language"></a>
          <a class="displayA" v-bind:href="'./onlineFeactureStory?lang='+$store.state.language"></a>
          <a class="displayA" v-bind:href="'./onlineSideStory?lang='+$store.state.language"></a>
          <a class="displayA" v-bind:href="'./onlineColumn?lang='+$store.state.language"></a>
    </div>
    
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  props: ['childLogGaEvent'],
  mounted() {
    // 
    // this.getIssueContent(this.magazineId)
   
  },
  methods: {
     changeInnerTab(zi){
         if(zi == 'All'){
          if(this.$route.params.magazineId){
            this.$router.push({
                path:"/magazine/"+this.$route.params.magazineId,
                query:{lang:this.$store.state.language}
            })
          }else{
            this.$router.push({
                path:"/magazine",
                query:{lang:this.$store.state.language}
            })
          }
            this.$store.state.zi = 'All';
         }else if(zi == 'Feature Story'){
            this.$router.push({
                path:"/onlineFeactureStory",
                query:{lang:this.$store.state.language}
            })
             this.$store.state.zi = 'Feature Story'
         }else if(zi == 'Side Story'){
              this.$router.push({
                path:"/onlineSideStory",
                query:{lang:this.$store.state.language}
            })
              this.$store.state.zi = 'Side Story'
         }else if(zi == 'Column'){
              this.$router.push({
                path:"/onlineColumn",
                query:{lang:this.$store.state.language}
            })
              this.$store.state.zi = 'Column'
         }
         if(this.childLogGaEvent){
           this.childLogGaEvent('userClick','magazineTab',zi)
         }
     },
  },
  computed: {
      zi(){
          return this.$store.state.zi;
          
      }
  },
  
};
</script>